import { Ticket } from '../types/ticket';
import { RuleContext } from './RuleContext';
import { RuleSetStrategy } from './strategies/RuleSetStrategy';

export class TicketRulesApplier {
  private readonly strategy: RuleSetStrategy;

  constructor(strategy: RuleSetStrategy) {
    this.strategy = strategy;
  }

  apply(context: RuleContext): Ticket[] {
    const rules = this.strategy.getRules(context);
    return rules.reduce((tickets, rule) => rule.apply({ ...context, tickets }), context.tickets);
  }
}
